import type { SVGProps } from 'react';

/**
 * Disha brand mark — a 4-point compass-rose star ("north star") with an
 * elongated north point. Encodes the meaning of "disha" (Sanskrit: direction
 * / guidance) into the visual language of the app.
 *
 * `currentColor` drives the rounded-square background, so the mark inherits
 * the surrounding text color (e.g. primary on the splash, foreground in the
 * sidebar). The inner star and small accent dot stay white / primary
 * respectively so the geometry reads at every size from 16px to 1024px.
 */
export function LogoMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="disha-logo-title"
      {...props}
    >
      <title id="disha-logo-title">Disha</title>
      <rect width="512" height="512" rx="112" fill="currentColor" />
      <path
        fill="white"
        d="M 256 88 L 280 232 L 424 256 L 280 280 L 256 424 L 232 280 L 88 256 L 232 232 Z"
      />
      <circle cx="256" cy="256" r="14" fill="currentColor" />
    </svg>
  );
}
